import React from 'react';
import {Path} from "../../components/svg/components/path";
import {Svg} from "../../components/svg/components/Svg";
import classNames from "classnames";
import styles from "./keyboard-arrow.module.scss";

export const KeyboardArrowDown = ({style,className}) => {
  return <Svg className={classNames(className, styles.default)} style={style}>
    <Path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
  </Svg>
}
